import styled from "styled-components";
import { pxToRem } from "../../styles/utils";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  background: radial-gradient(
      51% 51% at 50% 121%,
      ${({ theme }) => theme.colors.brandLight},
      ${({ theme }) => theme.colors.brandTransparent}
    ),
    ${({ theme }) => theme.colors.canvas};
`;

export const Logo = styled.h1`
  color: ${({ theme }) => theme.colors.brand};
  font-size: ${pxToRem(32)};
  font-weight: 700;
  line-height: ${pxToRem(35)};
  margin-bottom: auto;
  margin-top: ${pxToRem(30)};
`;
